import React from 'react';
import { CountryCode } from '~/enums';
import { useSelector } from 'react-redux';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store/types/sharedTypes';
import {
  ContentContainer,
  ListItem,
  ListItemBold,
  OrderedListContainer,
  Paragraph,
  UnorderedListContainer,
} from './styledComponents';

const TermsAndConditionsModal: React.FC = () => {
  const translate = useTranslate();
  const {
    intl: { market },
  } = useSelector((state: RootState) => state);

  return (
    <ContentContainer>
      <OrderedListContainer>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText1'
            ) as string
          }
        </ListItemBold>
        {market === CountryCode.BE && (
          <Paragraph>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText1'
              ) as string
            }
          </Paragraph>
        )}
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText2'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText3'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText4'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText5'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText6'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText7'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText8'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText9'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText10'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText11'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText12'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText13'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {translate('TermsAndConfirmationCard.UserAgreementPopupText14', {
            lineBreak: (
              <>
                <br />
                <br />
              </>
            ),
          })}
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText15'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText16'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText17'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText18'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText19'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText20'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText21'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText22'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText23'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText24'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText25'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText26'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText27'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText28'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText29'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText30'
            ) as string
          }
        </Paragraph>

        <UnorderedListContainer>
          <ListItemBold>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText31'
              ) as string
            }
          </ListItemBold>
          <Paragraph>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText32'
              ) as string
            }
          </Paragraph>
          <ListItemBold>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText33'
              ) as string
            }
          </ListItemBold>
          <Paragraph>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText34'
              ) as string
            }
          </Paragraph>
          <ListItemBold>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText35'
              ) as string
            }
          </ListItemBold>
          <Paragraph>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText36'
              ) as string
            }
          </Paragraph>
          <ListItemBold>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText37'
              ) as string
            }
          </ListItemBold>
          <Paragraph>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText38'
              ) as string
            }
          </Paragraph>
          <ListItemBold>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText39'
              ) as string
            }
          </ListItemBold>
          <Paragraph>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText40'
              ) as string
            }
          </Paragraph>
          {market === CountryCode.BE && (
            <>
              <ListItemBold>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText2'
                  ) as string
                }
              </ListItemBold>
              <Paragraph>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText3'
                  ) as string
                }
              </Paragraph>
            </>
          )}
        </UnorderedListContainer>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText41'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText42'
            ) as string
          }
        </Paragraph>
        <OrderedListContainer>
          <ListItem>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText43'
              ) as string
            }
          </ListItem>
          <ListItem>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText44'
              ) as string
            }
          </ListItem>
          <ListItem>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText45'
              ) as string
            }
          </ListItem>
          <ListItem>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText46'
              ) as string
            }
          </ListItem>
          <ListItem>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText47'
              ) as string
            }
          </ListItem>
          <ListItem>
            {
              translate(
                'TermsAndConfirmationCard.UserAgreementPopupText48'
              ) as string
            }
          </ListItem>
          {market !== CountryCode.BE && (
            <>
              {market === CountryCode.NO ? (
                <Paragraph>
                  {
                    translate(
                      'TermsAndConfirmationCard.UserAgreementPopupText49'
                    ) as string
                  }
                </Paragraph>
              ) : (
                <ListItem>
                  {
                    translate(
                      'TermsAndConfirmationCard.UserAgreementPopupText49'
                    ) as string
                  }
                </ListItem>
              )}
            </>
          )}
          {(market === CountryCode.BE || market === CountryCode.NL) && (
            <>
              <ListItem>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText4'
                  ) as string
                }
              </ListItem>
              <ListItem>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText5'
                  ) as string
                }
              </ListItem>
              <ListItem>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText6'
                  ) as string
                }
              </ListItem>
              <ListItem>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText7'
                  ) as string
                }
              </ListItem>
              <ListItem>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText8'
                  ) as string
                }
              </ListItem>
            </>
          )}
        </OrderedListContainer>
        {(market === CountryCode.BE || market === CountryCode.NL) && (
          <>
            <ListItemBold>
              {
                translate(
                  'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText9'
                ) as string
              }
            </ListItemBold>
            <Paragraph>
              {
                translate(
                  'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText10'
                ) as string
              }
            </Paragraph>
            <ListItemBold>
              {
                translate(
                  'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText11'
                ) as string
              }
            </ListItemBold>
            <OrderedListContainer>
              <ListItemBold>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText12'
                  ) as string
                }
              </ListItemBold>
              <Paragraph>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText13'
                  ) as string
                }
              </Paragraph>
              <ListItemBold>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText14'
                  ) as string
                }
              </ListItemBold>
              <Paragraph>
                {
                  translate(
                    'TermsAndConfirmationCard.UserAgreementBelgiumSpecificText15'
                  ) as string
                }
              </Paragraph>
            </OrderedListContainer>
          </>
        )}
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText50'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText51'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText52'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText53'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText54'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText55'
            ) as string
          }
        </Paragraph>
        {market !== CountryCode.BE && (
          <>
            <ListItemBold>
              {
                translate(
                  'TermsAndConfirmationCard.UserAgreementPopupText56'
                ) as string
              }
            </ListItemBold>
            <Paragraph>
              {
                translate(
                  'TermsAndConfirmationCard.UserAgreementPopupText57'
                ) as string
              }
            </Paragraph>
          </>
        )}

        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText58'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText59'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText60'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText61'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText62'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText63'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText64'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText65'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText66'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText67'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText68'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText69'
            ) as string
          }
        </Paragraph>
        <ListItemBold>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText70'
            ) as string
          }
        </ListItemBold>
        <Paragraph>
          {
            translate(
              'TermsAndConfirmationCard.UserAgreementPopupText71'
            ) as string
          }
        </Paragraph>
        {market === CountryCode.NO && (
          <>
            <ListItemBold>
              {
                translate(
                  'TermsAndConfirmationCard.UserAgreementNorwaySpecificTitle'
                ) as string
              }
            </ListItemBold>
            <Paragraph>
              {
                translate(
                  'TermsAndConfirmationCard.UserAgreementNorwaySpecificText'
                ) as string
              }
            </Paragraph>
          </>
        )}
      </OrderedListContainer>
    </ContentContainer>
  );
};

export default TermsAndConditionsModal;
